// Vue directive: keeps an element's scrollbar invisible at rest so it doesn't cut
// into rounded corners; only reveals it while actively scrolling, then fades it back
// out shortly after scrolling stops. Pairs with the `tw:scrollbar-autohide` utility
// (src/assets/css/tailwind.css), which styles the `is-scrolling` state.
const HIDE_DELAY = 800;

export default {
    bind(el) {
        el.__autoHideScrollbar__ = () => {
            el.classList.add('is-scrolling');
            clearTimeout(el.__autoHideScrollbarTimeout__);
            el.__autoHideScrollbarTimeout__ = setTimeout(() => {
                el.classList.remove('is-scrolling');
            }, HIDE_DELAY);
        };
        el.addEventListener('scroll', el.__autoHideScrollbar__, { passive: true });
    },
    unbind(el) {
        el.removeEventListener('scroll', el.__autoHideScrollbar__);
        clearTimeout(el.__autoHideScrollbarTimeout__);
        delete el.__autoHideScrollbar__;
        delete el.__autoHideScrollbarTimeout__;
    },
};
